import { createAction, props } from '@ngrx/store';

import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { Container } from 'app/shared/features/container-selector/models';
import { Locations } from 'app/shared/features/location-selector/models';
import { ComponentState } from 'app/state/manual-flow/select-state';

import { ResultRegistrationFlowRegistrationData } from './result-registration-flow.reducer';

export const initResultRegistrationFlow = createAction('[ResultRegistrationFlow] Initialize');

export const initResultRegistrationFlowSuccess = createAction(
    '[ResultRegistrationFlow] Initialization Success',
);

export const updateResultRegistrationFlowRegistrationDataInStorage = createAction(
    '[ResultRegistrationFlow] Update Scan Flow Registration Data In Storage',
    props<ResultRegistrationFlowRegistrationData>(),
);

export const applyResultRegistrationFlowRegistrationDataFromStorage = createAction(
    '[ResultRegistrationFlow] Apply Registration Data From Storage',
    props<{
        registrationDataFromStorage: ResultRegistrationFlowRegistrationData | undefined;
    }>(),
);

export const resetResultRegistrationFlowRegistrationData = createAction(
    '[ResultRegistrationFlow] Reset Registration Data in Result Registration',
);

export const selectActivityInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Select Activity In Result Registration Flow',
);

export const setActivityInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set Activity In Result Registration Flow',
    props<{
        activity: Activity;
    }>(),
);

export const setResultRegistrationFlowComponentState = createAction(
    '[ResultRegistrationFlow] Set Component State In Result Registration Flow',
    props<{ componentState: ComponentState }>(),
);

export const resultRegistrationFlowComponentStateUpdated = createAction(
    '[ResultRegistrationFlow] Component State In Result Registration Flow Updated',
);

export const setBatchInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set batch In Result Registration Flow',
    props<{ batchNumber: number }>(),
);

export const setContainerInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set container In Result Registration Flow',
    props<{ containerList: Container[] }>(),
);

export const setLocationInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set Location In Result Registration Flow',
    props<Locations>(),
);

export const setLocationInResultRegistrationFlowWithoutMeasurementType = createAction(
    '[ResultRegistrationFlow] Set Location In Result Registration Flow Without Measurement Type',
    props<Locations>(),
);

export const setAmountResultInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set Amount Result In Result Registration Flow',
    props<{ amountResult: number | undefined }>(),
);

export const setRowInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set Row In Result Registration Flow',
);

export const setAmountAndProductBoxInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set Product Box In Result Registration Flow',
    props<{ updatedProductBoxRegistrations: ProductBoxRegistration[] }>(),
);

export const setEmployeeInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Set employee In Result Registration Flow',
    props<{ employeeNumber: number }>(),
);

export const setEmployeeInResultRegistrationFlowWithoutMeasurementType = createAction(
    '[ResultRegistrationFlow] Set employee In Result Registration Flow Without Measurement Type',
    props<{ employeeNumber: number }>(),
);

export const goBackInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Go to previous state in result registration',
);

export const createContainerMeasurementInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Create Container Measurement In Result Registration Flow',
);

export const createRegistrationInResultRegistrationFlow = createAction(
    '[ResultRegistrationFlow] Create Registration In Result Registration Flow',
);
